import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver/FileSaver'
import moment from 'moment'
import axios from 'axios'
import Container from '@/components/Container/Container'
import SessionRow from '@/components/SessionRow/SessionRow'
import Spinner from '@/components/Spinner/Spinner'
import Pagination from '@/components/Pagination/Pagination'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Sessions',
  data() {
    return {
      csvLoading: false,
      zipLoading: false,
      vehicleId: null,
      exportError: null
    }
  },
  components: {
    Container,
    Spinner,
    FontAwesomeIcon,
    Pagination,
    SessionRow
  },
  created() {
    const vehicleId = this.$route.query.vehicle
    const page = this.$route.query.page
    if (page) this.$store.dispatch('setSessionPage', { page: parseInt(page) })
    if (!vehicleId) this.$router.push('/vehicles')
    this.vehicleId = vehicleId
    this.getSessions(vehicleId, page)
  },
  computed: {
    ...mapGetters({
      isLoading: 'allSessionsLoading',
      error: 'sessionsError',
      sessions: 'sessions',
      vehicle: 'vehicle',
      count: 'sessionCount',
      page: 'sessionPage',
      currentUser: 'currentUser'
    })
  },
  watch: {
    page(val) {
      const query = {
        vehicle: this.vehicleId
      }
      if (val !== 1) query.page = val
      this.$router.push({ path: 'sessions', query })
      this.getSessions(this.vehicleId, val)
    }
  },
  methods: {
    getSessions(vehicleId, page = 1) {
      this.$store.dispatch('getSessions', { vehicle: vehicleId, page }).then(sessions => {
        for (const session of sessions) {
          this.$store.dispatch('getSessionStatistics', { session: session.sessionid })
        }
      })
      this.$store.dispatch('getVehicle', vehicleId)
    },
    selectAllSessions() {
      this.$store.dispatch('selectAllSessions')
    },
    exportSessions(type) {
      this.exportError = null
      this[`${type}Loading`] = true
      const selectedSessions = this.sessions
        .filter(session => session.checked)
        .map(session => session.sessionid)
      if (selectedSessions.length === 0) {
        this[`${type}Loading`] = false
        this.exportError = 'Selecteer eerst eens sessie'
        return
      }
      const exportURL = `${this.$store.state.api.host}/${
        this.$store.state.api.endpoints.export
      }/?sessions=${selectedSessions}&format=${type}`
      axios({
        method: 'get',
        url: exportURL,
        responseType: 'blob'
      }).then(response => {
        const filename = `SEMS-export-${
          selectedSessions.length === 1
            ? selectedSessions[0]
            : moment(new Date()).utcOffset('+0100').format('YYYY-MM-DD')
        }.${type}`
        saveAs(response.data, filename)
        this[`${type}Loading`] = false
      })
      .catch(() => {
        this.exportError = 'Voor deze sessie(s) is helaas geen data beschikbaar'
        this[`${type}Loading`] = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Sessions/script.js